import React from "react"
import { StickyActionBar } from "../../components/sticky-action-bar/StickyActionBar";
import { MetricRunningTotal } from "../models/shared/metric-running-total";

interface IProps {
    totals : any|MetricRunningTotal;
    rowSelected?: boolean;
    shouldShow: boolean;
    loadLabel?: string;
}
export const MetricTotals = (props : IProps) => {

    return (
        props.shouldShow
        ? <StickyActionBar
                classes="planning-running-totals"
                showBar={true}>
                <div className={`running-total-bar metric-bar ${ props.rowSelected ? 'coverhighlights' : '' } `}>
                    <div>
                        <div className="total-group">
                            <div className="group-label subassembly"><span>2283</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_SA_2283_W() > 0 ? 'highlight' : '' } `}>
                                    <span>W</span>
                                    <span>{props.totals.getMETRIC_SA_2283_W()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_SA_2283_OW() > 0 ? 'highlight' : '' } `}>
                                    <span>OW</span>
                                    <span>{props.totals.getMETRIC_SA_2283_OW()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_SA_2283_OD() > 0 ? 'highlight' : '' } `}>
                                    <span>OD</span>
                                    <span>{props.totals.getMETRIC_SA_2283_OD()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_SA_FR_90() > 0 ? 'highlight' : '' } `}>
                                    <span>90</span>
                                    <span>{props.totals.getMETRIC_SA_FR_90()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label subassembly"><span>RIB</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_SA_RIB_W() > 0 ? 'highlight' : '' } `}>
                                    <span>W</span>
                                    <span>{props.totals.getMETRIC_SA_RIB_W()}</span>
                                </p>                                
                            </div>
                        </div>

                        <div className="total-group">
                        <div className="group-label subassembly"><span>&nbsp;</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_SA_FIP() > 0 ? 'highlight' : '' } `}>
                                    <span>FIP</span>
                                    <span>{props.totals.getMETRIC_SA_FIP()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                        <div className="group-label print"><span>&nbsp;</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${props.totals.getMETRIC_PRINT_W() > 0 ? 'highlight' : ''} `}>
                                    <span>AW</span>
                                    <span>{props.totals.getMETRIC_PRINT_W()}</span>
                                </p>
                                <p className={`rollup-metric ${props.totals.getMETRIC_PRINT_D() > 0 ? 'highlight' : ''} `}>
                                    <span>AD</span>
                                    <span>{props.totals.getMETRIC_PRINT_D()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label windows"><span>WINDOWS</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_WIN_RP() > 0 ? 'highlight' : '' } `}>
                                    <span>RP</span>
                                    <span>{props.totals.getMETRIC_WIN_RP()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_WIN_83() > 0 ? 'highlight' : '' } `}>
                                    <span>83</span>
                                    <span>{props.totals.getMETRIC_WIN_83()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_WIN_FP() > 0 ? 'highlight' : '' } `}>
                                    <span>FP</span>
                                    <span>{props.totals.getMETRIC_WIN_FP()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_WIN_AP() > 0 ? 'highlight' : '' } `}>
                                    <span>AP</span>
                                    <span>{props.totals.getMETRIC_WIN_AP()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_WIN_RIB() > 0 ? 'highlight' : '' } `}>
                                    <span>RB</span>
                                    <span>{props.totals.getMETRIC_WIN_RIB()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label assembly"><span>ASSEMBLY</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_ASM_RP() > 0 ? 'highlight' : '' } `}>
                                    <span>RP</span>
                                    <span>{props.totals.getMETRIC_ASM_RP()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_ASM_83() > 0 ? 'highlight' : '' } `}>
                                    <span>83</span>
                                    <span>{props.totals.getMETRIC_ASM_83()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_ASM_FP() > 0 ? 'highlight' : '' } `}>
                                    <span>FP</span>
                                    <span>{props.totals.getMETRIC_ASM_FP()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_ASM_AP() > 0 ? 'highlight' : '' } `}>
                                    <span>AP</span>
                                    <span>{props.totals.getMETRIC_ASM_AP()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_ASM_RB() > 0 ? 'highlight' : '' } `}>
                                    <span>RB</span>
                                    <span>{props.totals.getMETRIC_ASM_RB()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_ASM_FV() > 0 ? 'highlight' : '' } `}>
                                    <span>FV</span>
                                    <span>{props.totals.getMETRIC_ASM_FV()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_ASM_CH() > 0 ? 'highlight' : '' } `}>
                                    <span>CH</span>
                                    <span>{props.totals.getMETRIC_ASM_CH()}</span>
                                </p>
                                <p className={`rollup-metric ${props.totals.getMETRIC_ASM_I() > 0 ? 'highlight' : ''} `}>
                                    <span>I</span>
                                    <span>{props.totals.getMETRIC_ASM_I()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label loading"><span>&nbsp;</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_LOAD_SEC() > 0 ? 'highlight' : '' } `}>
                                    <span>{ props.loadLabel ?? 'LOAD' }</span>
                                    <span>{props.totals.getMETRIC_LOAD_SEC()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label hw-subassembly"><span>TRACK</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_TR_RES() > 0 ? 'highlight' : '' } `}>
                                    <span>RES</span>
                                    <span>{props.totals.getMETRIC_TR_RES()}</span>
                                </p>

                                <p className={`rollup-metric ${ props.totals.getMETRIC_TR_COMM() > 0 ? 'highlight' : '' } `}>
                                    <span>COMM</span>
                                    <span>{props.totals.getMETRIC_TR_COMM()}</span>
                                </p>
                                <p className={`rollup-metric ${ props.totals.getMETRIC_TR_LHR() > 0 ? 'highlight' : '' } `}>
                                    <span>LHR</span>
                                    <span>{props.totals.getMETRIC_TR_LHR()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label hw-subassembly"><span>SPRINGS</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${props.totals.getMETRIC_SPRINGS_RES() > 0 ? 'highlight' : ''} `}>
                                    <span>RES</span>
                                    <span>{props.totals.getMETRIC_SPRINGS_RES()}</span>
                                </p>

                                <p className={`rollup-metric ${props.totals.getMETRIC_SPRINGS_COMM() > 0 ? 'highlight' : ''} `}>
                                    <span>COMM</span>
                                    <span>{props.totals.getMETRIC_SPRINGS_COMM()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label hw-subassembly"><span>&nbsp;</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_STRUTS() > 0 ? 'highlight' : '' } `}>
                                    <span>STRUTS</span>
                                    <span>{props.totals.getMETRIC_STRUTS()}</span>
                                </p>
                            </div>
                        </div>

                        <div className="total-group">
                            <div className="group-label hw-subassembly"><span>&nbsp;</span></div>
                            <div className="metrics">
                                <p className={`rollup-metric ${ props.totals.getMETRIC_HW() > 0 ? 'highlight' : '' } `}>
                                    <span>HDW</span>
                                    <span>{props.totals.getMETRIC_HW()}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </StickyActionBar>
        : null
    );
}
